<template>
  <oie-base-input-v2
    v-model="vatNumber"
    v-bind="$attrs"
    :label="`${t('vatLabel')}`"
    :placeholder="t('vatPlaceholder')"
    maxlength="18"
    :prefix="countryCode"
    v-on="$listeners"></oie-base-input-v2>
</template>

<script>
import utils from '@/core/utils'

export default {
  props: {
    countryCode: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number, Date],
      default: null
    }
  },
  data() {
    return {
      vatNumber: ''
    }
  },
  watch: {
    vatNumber(newValue) {
      this.$emit('input', utils.saveVatNumberWithFormating(newValue, this.countryCode))
    },
    countryCode(newValue) {
      this.$emit('input', utils.saveVatNumberWithFormating(this.vatNumber, newValue))
    }
  },
  beforeMount() {
    if(this.value) {
      this.vatNumber = utils.extractVatNumberFromFormating(this.value, this.countryCode)
    }
  }

}
</script>

<style lang="scss">

</style>
